module.exports = __webpack_public_path__ + "img/ihs-logo.39e3a500.svg";